<template>
  <side-base fulled>
    <div class="swrap">
      <div class="smain">
        <!-- 课程/班级 -->
        <div class="head" v-if="info.commodityType === 1 || info.commodityType === 2">
          <svg
            class="vxm-icon l"
            aria-hidden="true"
            font-size="24"
            style="margin-right: calc(var(--gap) * 8)"
          >
            <use v-if="info.commodityType === 1" xlink:href="#vxm-icon-banji"></use>
            <use v-else-if="info.commodityType === 2" xlink:href="#vxm-icon-kecheng"></use>
          </svg>

          <div class="r" v-if="info.commodityType === 1">
            <div class="r1 van-ellipsis">
              {{ info.productName }}
            </div>
          </div>

          <div class="r" v-if="info.commodityType === 2">
            <div class="r1 van-ellipsis">{{ info.curriculumName }}</div>
          </div>
        </div>

        <!-- 物品 -->
        <div class="head" v-if="info.commodityType === 0">
          <svg
            class="vxm-icon l"
            aria-hidden="true"
            font-size="24"
            style="margin-right: calc(var(--gap) * 8)"
          >
            <use xlink:href="#vxm-icon-wupin"></use>
          </svg>

          <div class="r">
            <div class="r1 van-ellipsis">
              {{ info.productName }}
            </div>
            <!-- <div class="r2 van-ellipsis" v-if="info.priceItemDetail.commodityPriceType == 2">
              {{ info.priceItemDetail.priceName }}
            </div> -->
          </div>
        </div>

        <!-- 课时包 -->
        <div class="head" v-if="info.commodityType === 4">
          <div class="l cardtag">课时包</div>
          <div class="r">
            <div class="r1 van-ellipsis">
              {{ info.productName }}
            </div>
          </div>
        </div>

        <belonger-input v-model="list" @error="errMsg = $event"></belonger-input>
      </div>

      <side-foot @cancel="close" @confirm="confirm(getRet())" />
    </div>
  </side-base>
</template>

<script>
import belongerInput from '@teacher/components/belonger-input.vue';
import sideMixinBase from '@x3/js/side/0_mixin/mixin-base.js';

export default {
  name: 'x3-side-belonger',
  mixins: [sideMixinBase],
  components: {
    belongerInput,
  },
  data() {
    return {
      pageTitle: '编辑业绩归属人',
      list: [],
      info: {},
      errMsg: '',
    };
  },
  methods: {
    init() {
      let opts = this.$vxRoute.meta.options || {};

      if (opts.list) {
        let initList = app.tool.clone(opts.list);
        this.info = app.tool.clone(opts.info);
        this.list = initList.map(itm => {
          return {
            // id待删除，需与王杰对接联调
            id: itm.id || itm.teacherId,
            teacherId: itm.teacherId,
            name: itm.teacherName,
            scaleStr: itm.scaleStr,
          };
        });
      }
    },
    getRet() {
      let ret = false;
      if (this.errMsg) {
        vant.Toast(this.errMsg);
        ret = 'occlude';
      } else {
        ret = this.list;
      }
      return ret;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .smain {
    flex: 1;
    overflow: auto;
  }
}

.head {
  padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
  background: rgba(var(--g2-rgb), 0.3);
  display: flex;
  align-items: center;
  .l {
    margin-right: calc(var(--gap) * 8);
    flex: none;
    &.cardtag {
      height: 24px;
      padding: 0 calc(var(--gap) * 2);
      color: var(--white);
      background: var(--c1);
      display: flex;
      align-items: center;
    }
  }
  .r {
    flex: 1;
    overflow: hidden;
    .r1 {
      color: var(--g8);
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
      font-weight: 600;
    }
    .r2 {
      margin-top: calc(var(--gap) * 6);
      color: var(--g6);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
    }
  }
}
</style>